var map = {
	"./en-US.json": 371,
	"./vi-VN.json": 178
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 370;


//////////////////
// WEBPACK FOOTER
// ./src/resources ^\.\/.*\.json$
// module id = 370
// module chunks = 0